import Vue from 'vue'
import App from './App.vue'

import VueResource from 'vue-resource';
import store from './store';
import pages from './components/Pages/pages.vue'
import page from './components/Page/page.vue'

Vue.config.productionTip = false

Vue.use(VueResource);
Vue.component('pages', pages);
Vue.component('page', page);

new Vue({
  render: h => h(App),
  store: store,
}).$mount('#app')
